export const columns = [
    {
        name: "id",
        label: "SNo.",
        sort: false,
    },
    {
        name: "name",
        label: "Name",
        sort: false,
    },
    {
        name: "email",
        label: "Email",
        sort: false,
    },
    // Cadre and designation in place of mobile and registration date, so a
    // reviewer can tell who the candidate is from the list itself.
    {
        name: "cadre",
        label: "Cadre",
        sort: false,
    },
    {
        name: "designation",
        label: "Designation",
        sort: false,
    },
    {
        name: "aadhar",
        label: "Aadhar No",
        sort: false,
    },
    {
        name: "docUploadDate",
        label: "Doc Uploaded",
        sort: false,
    },
    {
        name: "action",
        label: "View",
        sort: false,
    },

];

export const paymentColumn = [
    {
        name: "id",
        label: "SNo.",
        sort: false,
    },
    {
        name: "aadhar",
        label: "Aadhar No",
        sort: false,
    },
    {
        name: "date",
        label: "Exam Date",
        sort: false,
    },
    {
        name: "name",
        label: "Name",
        sort: false,
    },
    {
        name: "subName",
        label: "Subject Name",
        sort: false,
    },
    {
        name: "orderId",
        label: "Order Id",
        sort: false,
    },
    {
        name:"paymentStatus",
        label: "Payment Status",
        sort: false,
    },
    {
        name:"transactionAmount",
        label: "Amount",
        sort: false,
    },
    {
        name:"transactionReferenceNumber",
        label: "Reference Number",
        sort: false,
    },
    {
        name:"paymentDate",
        label: "Payment Date",
        sort: false,
    },

];

export const allDropdown = [
    {
        label: "All",
        value: "all"
    },
    {
        label: "Active",
        value: "isActive"
    },
    {
        label: "Cancelled",
        value: "isCancelled"
    }, {
        label: "Deleted",
        value: "isDeleted"
    }
]